import React from 'react';

import AvGroup from './AvGroup';
import TitleInput from './TitleInput';

export default props => (
  <AvGroup>
    <TitleInput {...props} />
  </AvGroup>
);
